<template>
  <BootstrapModal :show="showModal"
                  :trigger-class=triggerClass
                  :trigger-icon=triggerIcon :trigger-text="triggerText"
                  submit-btn="Speichern" title="Anmerkungen zum Plan einfügen" @close="handleClose" @open="handleOpen"
                  @save="handleSave">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="datetime">Datum</label>
          <input id="datetime"
                 :value="this.scheduleAnnotation.datetime && this.scheduleAnnotation.datetime.slice(0, 16)"
                 class="form-control"
                 required
                 type="datetime-local"
                 @input="this.scheduleAnnotation.datetime = new Date($event.target.value + 'Z').toISOString().slice(0, 16)">
        </div>
        <div class="col">
          <label class="form-label" for="text">Text</label>
          <textarea id="text" v-model="this.scheduleAnnotation.text" class="form-control"></textarea>
        </div>
        <div class="col">
          <label class="form-label" for="color">Farbe</label>
          <input id="color" v-model="this.scheduleAnnotation.color" class="form-control form-control-color"
                 type="color">
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="showDate">Datum anzeigen</label>
            <input id="showDate" v-model="this.scheduleAnnotation.showDate" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="showTime">Uhrzeit anzeigen</label>
            <input id="showTime" v-model="this.scheduleAnnotation.showTime" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="bold">Fett drucken</label>
            <input id="bold" v-model="this.scheduleAnnotation.bold" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="image">Bild</label>
          <select v-model="this.scheduleAnnotation.image" aria-label="Select Image" class="form-select">
            <option :value="null" selected>-</option>
            <option v-for="image in this.mediaStore.data" :key="image.id" :value="image.id">{{ image.name }}</option>
          </select>
        </div>
        <div v-if="scheduleAnnotation.image" class="col">
          <label class="form-label" for="imageWidth">Bildbreite [mm]</label>
          <input id="imageWidth" v-model="this.scheduleAnnotation.imageWidth" class="form-control" min="1"
                 type="number">
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "@/components/BootstrapModal";
import {useScheduleAnnotationStore} from "@/stores/scheduleAnnotation";
import {useMediaStore} from "@/stores/media";

export default {
  name: "ScheduleAnnotationCreateEditModal",
  props: ['passInScheduleAnnotation', 'scheduleId', 'triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      scheduleAnnotation: {},
      showModal: false,
    }
  },
  methods: {
    handleOpen() {
      this.showModal = true;
      this.scheduleAnnotation = this.passInScheduleAnnotation == null ? {
        showDate: true,
        showTime: true,
        schedule: this.scheduleId
      } : this.passInScheduleAnnotation;
    },
    handleClose() {
      this.showModal = false;
      this.scheduleAnnotation = {};
    },
    handleSave() {
      if (this.scheduleAnnotation.id == null)
        this.scheduleAnnotationStore.addItem(this.scheduleAnnotation);
      else
        this.scheduleAnnotationStore.updateItem(this.scheduleAnnotation);
      this.handleClose();
    },
  },
  setup() {
    const scheduleAnnotationStore = useScheduleAnnotationStore();
    const mediaStore = useMediaStore();
    return {scheduleAnnotationStore, mediaStore};
  },
  created() {
    if (!this.mediaStore.loadedData)
      this.mediaStore.getData();
  },
  components: {BootstrapModal}
}
</script>
